/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsEndpointDto } from './ExternalCsmsEndpointDto';
import {
    ExternalCsmsEndpointDtoFromJSON,
    ExternalCsmsEndpointDtoFromJSONTyped,
    ExternalCsmsEndpointDtoToJSON,
    ExternalCsmsEndpointDtoToJSONTyped,
} from './ExternalCsmsEndpointDto';

/**
 * 
 * @export
 * @interface ExternalCsmsConfigDto
 */
export interface ExternalCsmsConfigDto {
    /**
     * Monotonic Organization-level CSMS configuration revision (persisted as Organization.csmsConfigVersion). Present on responses; ignored if sent on requests.
     * @type {number}
     * @memberof ExternalCsmsConfigDto
     */
    readonly configVersion?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalCsmsConfigDto
     */
    chargerAuthenticationEnabled?: boolean;
    /**
     * CSMS endpoints (exactly one Primary; up to four Secondaries). Secondaries require a usable enabled Primary.
     * @type {Array<ExternalCsmsEndpointDto>}
     * @memberof ExternalCsmsConfigDto
     */
    endpoints: Array<ExternalCsmsEndpointDto>;
}

/**
 * Check if a given object implements the ExternalCsmsConfigDto interface.
 */
export function instanceOfExternalCsmsConfigDto(value: object): value is ExternalCsmsConfigDto {
    if (!('endpoints' in value) || value['endpoints'] === undefined) return false;
    return true;
}

export function ExternalCsmsConfigDtoFromJSON(json: any): ExternalCsmsConfigDto {
    return ExternalCsmsConfigDtoFromJSONTyped(json, false);
}

export function ExternalCsmsConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalCsmsConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'configVersion': json['configVersion'] == null ? undefined : json['configVersion'],
        'chargerAuthenticationEnabled': json['chargerAuthenticationEnabled'] == null ? undefined : json['chargerAuthenticationEnabled'],
        'endpoints': ((json['endpoints'] as Array<any>).map(ExternalCsmsEndpointDtoFromJSON)),
    };
}

export function ExternalCsmsConfigDtoToJSON(json: any): ExternalCsmsConfigDto {
    return ExternalCsmsConfigDtoToJSONTyped(json, false);
}

export function ExternalCsmsConfigDtoToJSONTyped(value?: Omit<ExternalCsmsConfigDto, 'configVersion'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chargerAuthenticationEnabled': value['chargerAuthenticationEnabled'],
        'endpoints': ((value['endpoints'] as Array<any>).map(ExternalCsmsEndpointDtoToJSON)),
    };
}

